import {
  OrderDraftPreferredCreationFlows,
  type OrderDraftPreferredCreationFlowEnum,
} from '@webapp/platform/iam/entities/enums/OrderDraftPreferredCreationFlowEnum'
import { UserPreferenceKeys } from '@webapp/platform/iam/entities/enums/UserPreferenceKeys'
import { type IUserRepository } from '../../interfaces/IUserRepository'

export class GetOrderRequestFlowPreferenceUseCase {
  constructor(
    private readonly deps: {
      userRepository: IUserRepository
    }
  ) {}

  execute = async (
    userId: number
  ): Promise<OrderDraftPreferredCreationFlowEnum> => {
    const preferredOrderRequestFlow =
      await this.deps.userRepository.getPreference(
        userId,
        UserPreferenceKeys.ORDER_REQUEST_FLOW
      )

    if (
      preferredOrderRequestFlow === OrderDraftPreferredCreationFlows.CLASSIC ||
      preferredOrderRequestFlow === OrderDraftPreferredCreationFlows.AI
    ) {
      return preferredOrderRequestFlow
    }

    return OrderDraftPreferredCreationFlows.CLASSIC
  }
}
